import { render, staticRenderFns } from "./CambiarPasswordForm.vue?vue&type=template&id=4fc2437c&"
import script from "./CambiarPasswordForm.vue?vue&type=script&lang=js&"
export * from "./CambiarPasswordForm.vue?vue&type=script&lang=js&"
import style0 from "./CambiarPasswordForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports